import script from "./Content.vue?vue&type=script&lang=ts&setup=true"
export * from "./Content.vue?vue&type=script&lang=ts&setup=true"

import "./Content.vue?vue&type=style&index=0&id=5a0d3b12&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0d3b12"]])

export default __exports__